import './bootstrap';

import { createApp } from "vue/dist/vue.esm-bundler";
import { autoAnimatePlugin } from '@formkit/auto-animate/vue'
import { createI18n } from 'vue-i18n'
import Notifications from '@kyvg/vue3-notification'

// Import ziggy.
import { ZiggyVue } from 'ziggy-js';

import languageBundle from "./translations/translations";

const app = createApp({});
const dom = document.getElementById('app');

const i18n = createI18n({
    legacy: false,
    locale: document.documentElement.lang,
    messages: languageBundle,
});

const components = import.meta.glob('./components/*.vue', { eager: true })

Object.entries(components).forEach(([path, definition]) => {
    const componentName = path.split('/').pop().replace(/\.\w+$/, '')
    // Register component on this Vue instance
    app.component(componentName, definition.default)
})

app.use(autoAnimatePlugin);
app.use(i18n);
app.use(ZiggyVue);
app.use(Notifications);
app.mount(dom);